var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBank(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon-ca_rd",
    "data-name": "icon-ca rd",
    transform: "translate(-240 -3397)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "bg",
    width: 80,
    height: 80,
    transform: "translate(240 3397)",
    fill: "#02fdb1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "fi-rr-piggy-bank",
    transform: "translate(260.041 3417)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67434",
    "data-name": "Group 67434",
    transform: "translate(-0.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_67433",
    "data-name": "Group 67433",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_80493",
    "data-name": "Path 80493",
    d: "M29.961,20a1.667,1.667,0,1,1-1.667-1.667A1.667,1.667,0,0,1,29.961,20ZM11.627,8.333a1.667,1.667,0,0,0,1.667-1.667,3.333,3.333,0,0,1,6.667,0,1.667,1.667,0,1,0,3.333,0,6.667,6.667,0,1,0-13.333,0A1.667,1.667,0,0,0,11.627,8.333ZM39.961,21.667V25a3.226,3.226,0,0,1-2.613,3.257,13.368,13.368,0,0,1-5.72,6.59V35a5,5,0,0,1-9.715,1.667H18.007A5,5,0,0,1,8.292,35v-.132A13.278,13.278,0,0,1,1.654,22.45a12.823,12.823,0,0,1,1.175-4.593A5,5,0,0,1,4.957,8.333a1.667,1.667,0,1,1,0,3.333,1.667,1.667,0,0,0-.3,3.307A13.967,13.967,0,0,1,15.4,10h8.938a9.438,9.438,0,0,1,6.545-4.91,3.283,3.283,0,0,1,2.8.623A3.333,3.333,0,0,1,34.959,8.34v6.192a13.425,13.425,0,0,1,2.387,3.878,3.225,3.225,0,0,1,2.613,3.257Zm-3.333,0h-.49a1.667,1.667,0,0,1-1.6-1.192A10.063,10.063,0,0,0,32.1,16.347a1.665,1.665,0,0,1-.475-1.163V8.34a6.039,6.039,0,0,0-4.607,3.892,1.656,1.656,0,0,1-1.65,1.14c-.113-.005-9.967-.037-9.967-.037A10.255,10.255,0,0,0,4.982,22.667a9.967,9.967,0,0,0,5.695,9.692,1.667,1.667,0,0,1,.95,1.505V35a1.667,1.667,0,0,0,3.333,0,1.667,1.667,0,0,1,1.667-1.667h6.667A1.666,1.666,0,0,1,24.961,35a1.667,1.667,0,0,0,3.333,0V33.845a1.667,1.667,0,0,1,.948-1.5,10.017,10.017,0,0,0,5.3-6.147A1.667,1.667,0,0,1,36.137,25h.49V21.67Z",
    transform: "translate(0.043)",
    fill: "#12784a"
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.5b35f90dbce87bf15f2f9af665ee300e.svg";
export { ForwardRef as ReactComponent };